import React from "react";

export const IconCheckEmpty = ({ size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="19" height="19" rx="9.5" fill="#DCE0FC" />
      <rect x="1" y="1" width="19" height="19" rx="9.5" stroke="#ABB4F4" />
    </svg>
  );
};
